import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

export default function MerchandiseServicesModal({
  isViewOpen,
  isViewToggle,
  merchandiseServicesList,
}) {
  return (
    <Modal isOpen={isViewOpen} toggle={isViewToggle} className="merchandise-services-wrapper">
      <ModalHeader>
        <i className="modal-close fas fa-times" onClick={isViewToggle} />
        <span className="modal-headername">ITEM SUMMARY</span>
      </ModalHeader>
      {Object.keys(merchandiseServicesList).length > 0 ? (
        <ModalBody>
          <div className="container-items-list">
            <p className="title">item name / item code</p>
            <ul className="items-list">
              {Object.values(merchandiseServicesList).map((item, index) => {
                return (
                  <li key={index.toString()}>
                    <div className="item-details">
                      <span className="item-name">{item?.itemName}</span>
                      <span className="item-code">{item?.code}</span>
                    </div>
                    <div className="item-qty">
                      Qty{' '}
                      <span>
                        {item?.quantity?.toLocaleString('en-US', {
                          minimumIntegerDigits: 2,
                          useGrouping: false,
                        }) || 0}
                      </span>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </ModalBody>
      ) : (
        <div className="merchandise-noitems">No Items Available</div>
      )}
    </Modal>
  );
}

MerchandiseServicesModal.propTypes = {
  isViewOpen: PropTypes.bool,
  isViewToggle: PropTypes.func,
  merchandiseServicesList: PropTypes.shape({}),
};
